//fake enum for accessory IDs
export const ActivityType = {
    IMPULSE: "impulse",
    SMART: "smart",
    MORE: "more",
    TOGETHER: "together",
}